import { captureException } from '@sentry/browser';
export default function captureItemFeeMembershipConstraint(itemId, feeId) {
  captureException(new Error('Tried to create an item fee membership for a fee that has a product set'), {
    contexts: {
      args: {
        itemId,
        feeId
      }
    }
  });
}